import React from "react";

import Layout from "../components/Layout"
import InputGroup from "../components/InputGroup";


export default function ScanPage(){
  return(
    <Layout>
      <InputGroup />
    </Layout>
  )
}
